import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PatientProvider } from '../../providers/patient/patient';
import { Subject } from 'rxjs';

@Component({
  selector: 'document-process-dialog',
  templateUrl: 'document-process-dialog.html'
})
export class DocumentProcessDialogComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  form: FormGroup;
  program_id: string;
  patient: string;
  patientv = false;
  patients: any[] = [];
  user: any;

  constructor(
    private db: PatientProvider,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<DocumentProcessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.patient = data.patient;
    this.program_id = data.program_id;
    this.patientv = data.patientv;
    console.log('Patient Version: ', this.patientv);
    this.db
    .listPatients(this.program_id)
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((patients) => {
      this.patients = patients;
    }); 
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      patient: [null, !this.patientv ? Validators.required : null],
      type: [null, Validators.required],
      notes: [null],
    })
  }

  ngOnDestroy() {
    console.log('Leaving classify document dialog and destroying subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  submit() {
    let document = this.form.value;
    this.dialogRef.close(document);
  }
}



// WEBPACK FOOTER //
// ./src/components/document-process-dialog/document-process-dialog.ts